const createButtonCompChecklist = {
  question: 'Crear Pregunta +'
};

export default createButtonCompChecklist;
